import React, { useEffect, useRef, useState } from "react";
import HeaderLayout from "./HeaderLayout";
import { Avatar, Button, Icons, Text } from "@evvve/ui-kit";
import style from "./style.module.scss";
import avatar_skeleton from "src/assets/images/avatar_skeleton.png";
import ButtonChat from "./ButtonChat";
import useOutsideClick from "src/hooks/useOutsideClick";
import HeaderMenu from "./HeaderMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../hooks/useStoreHooks";
import { CurrentUser } from "../../../store/User/types";
import { useGetIfHasUnreadMessagesQuery } from "src/store/chat/api";
import { sendAmplitudeData } from "../../../helpers/amplitude";

export enum AppPage {
  CREATE_EVENT = "CREATE_EVENT",
  EVENT_SPACE = "EVENT_SPACE",
  CHECK_DEVICES = "CHECK_DEVICES",
}

export interface HeaderProps {
  onClickChat?: () => void;
  isOpenChat?: boolean;
  page?: AppPage;
  desktopLayoutOnly?: boolean;
}

const { ChevronDown } = Icons;
const HeaderClosePart = ({
  onClickChat,
  isOpenChat = false,
  page,
  desktopLayoutOnly,
}: HeaderProps) => {
  const [openMenu, setOpenMenu] = useState(false);
  const location = useLocation();
  const node = useRef<HTMLDivElement>(null);
  const isOutside = useOutsideClick(openMenu, node);
  const navigate = useNavigate();

  const user: CurrentUser|null = useAppSelector(
    (state) => state.user.userInfo
  );

  const { data } = useGetIfHasUnreadMessagesQuery();

  useEffect(() => {
    isOutside && setOpenMenu(false);
  }, [isOutside]);

  const renderPadding = () => {
    switch (page) {
      case AppPage.CREATE_EVENT:
      case AppPage.CHECK_DEVICES:
        return style.padding_12_20;
      case AppPage.EVENT_SPACE:
        return style.padding_12;
      default:
        return style.padding_12_20;
    }
  };


  const getHeaderButtons = () => {
    switch (page) {
      case AppPage.CREATE_EVENT:
      case AppPage.CHECK_DEVICES:
        return <></>;
      case AppPage.EVENT_SPACE:
        return (
          <div className={style.wrap}>
            <Button
              className={desktopLayoutOnly ? style.exitEvent_speaker_org : style.exitEvent_attendee}
              size="l"
              type="flat"
              onClick={() => user
                ? navigate(`/profile/${user?.username}`)
                : navigate("/")}
            >
              <>
                <Icons.LogOut size="m" color="grayscale700" />
                <Text size="m" color="grayscale700" className={style.exitEvent_text}> Exit event </Text>
              </>
            </Button>
            {!desktopLayoutOnly && <ButtonChat
              isViolet={openMenu || isOpenChat}
              hasUnreadMessages={data?.unread_messages || false}
              onClick={onClickChat}
            />}
          </div>
        );
      default:
        return (
          <>
            <div className={style.buttonsGroup}>
              <Button
                size="s"
                type="outline"
                startIcon="Plus"
                theme="violet"
                onClick={() => {
                  sendAmplitudeData("Create event clicked");
                  navigate("/create-event");
                }}>
                        Create event
              </Button>
              <Button
                size="s"
                startIcon="Grid"
                onClick={() => navigate("/catalog", { state: { prevPath: location.pathname } })}
              >
                Find event
              </Button>
            </div>
            <ButtonChat
              isViolet={openMenu || isOpenChat}
              hasUnreadMessages={data?.unread_messages || false}
              onClick={onClickChat}
            />
          </>
        );
    }
  };

  const renderAccountElements = () => (
    <div className={`${style.buttonsSection} ${page === AppPage.EVENT_SPACE ? style.gap_36 : style.gap_24}`}>
      <>
        {getHeaderButtons()}
      </>
      <div ref={node} className={style.avatarCp} onClick={() => {
        setOpenMenu(!openMenu);
      }}>
        <Avatar
          size="s"
          status="offline"
          alt="avatar"
          src={user?.avatar_url ?? avatar_skeleton} />
        <div className={openMenu ? style.arrowDown : style.arrowUp}>
          <ChevronDown />
        </div>
        <div>
          <HeaderMenu openMenu={openMenu} />
        </div>
      </div>
    </div>
  );
  return (
    <HeaderLayout type="private" desktopLayoutOnly={desktopLayoutOnly}
      className={`
                  ${desktopLayoutOnly ? style.headerLayout_speaker_org : style.headerLayout_attendee}
                  ${renderPadding()}`
      }>
      {renderAccountElements()}
    </HeaderLayout>
  )
  ;
};

export default HeaderClosePart;